export enum ArchivesMutationTypes {
  SET_LIST_SEARCH_PENDING = 'SET_LIST_SEARCH_PENDING',
  SET_LIST_SEARCH_DATA = 'SET_LIST_SEARCH_DATA',
  SET_LIST_SEARCH_DATA_COUNT = 'SET_LIST_SEARCH_DATA_COUNT',
  SET_CONFIG = 'SET_CONFIG',
  SET_CONFIG_PENDING = 'SET_CONFIG_PENDING',
  SET_GET_ARCHIVE_RIGHTS_PENDING = 'SET_GET_ARCHIVE_RIGHTS_PENDING',
  SET_CURRENT_ARCHIVE_RIGHTS = 'SET_CURRENT_ARCHIVE_RIGHTS',
  SET_SEND_ARCHIVES_PENDING = 'SET_SEND_ARCHIVES_PENDING',
  SET_SHARE_ARCHIVES_PENDING = 'SET_SHARE_ARCHIVES_PENDING',
  SET_MUTE_ARCHIVING_WARNING = 'SET_MUTE_ARCHIVING_WARNING',
  ADD_UPLOAD_ARCHIVE_PENDING = 'ADD_UPLOAD_ARCHIVE_PENDING',
  REMOVE_UPLOAD_ARCHIVE_PENDING = 'REMOVE_UPLOAD_ARCHIVE_PENDING',
  ADD_UPLOAD_ARCHIVE_ERROR = 'ADD_UPLOAD_ARCHIVE_ERROR',
  REMOVE_UPLOAD_ARCHIVE_ERROR = 'REMOVE_UPLOAD_ARCHIVE_ERROR',
  ADD_POST_ARCHIVE_PENDING = 'ADD_POST_ARCHIVE_PENDING',
  REMOVE_POST_ARCHIVE_PENDING = 'REMOVE_POST_ARCHIVE_PENDING',
  ADD_POST_ARCHIVE_ERROR = 'ADD_POST_ARCHIVE_ERROR',
  REMOVE_POST_ARCHIVE_ERROR = 'REMOVE_POST_ARCHIVE_ERROR',
  SET_DISCOVER_ELECTRONIC_SAFE_DIALOG_IS_OPEN = 'SET_DISCOVER_ELECTRONIC_SAFE_DIALOG_IS_OPEN',
  SET_SELECTED_DOCUMENTS = 'SET_SELECTED_DOCUMENTS',
  SET_ARCHIVES_DOWNLOAD_PENDING = 'SET_ARCHIVES_DOWNLOAD_PENDING',
  REMOVE_DOCUMENT = 'REMOVE_DOCUMENT'
}
